<template>
<v-chip outlined small
  v-bind='attrs'
  @click="$emit('selected', value)" >

  <v-avatar v-if='logoPicture(value)' left >
    <v-img :src='logoPicture(value)' />
  </v-avatar>
  {{value.title}}

</v-chip>
</template>
<script>
export default {
  name: 'SpaceChip',
  props: {
    attrs: { type: Object, required: false },
    value: { type: Object, required: false },
    spaceId: { required: false }
  },
  data () {
    return {

    }
  }
}
</script>
